import React from 'react';


const do_nothing = () => { return };

  function ImageButton({ url, onClick, mouseEnter=do_nothing, mouseLeave=do_nothing, title='', size='medium', color='#efffef'}) {
    return (
      <button title={title} className='imagedButton'
      style={size === 'small' ? ({
        alignItems: 'center',
        justifyContent: 'top',
        width: '20px',
        height: '20px',
        border: 'none',
        'marginLeft': '3px',
        'marginRight': '3px',
        'marginTop': '1px',
        'marginBottom': '1px',
        padding: '3px', 
        borderRadius: '10%',
        backgroundColor: color,
        cursor: 'pointer',
        }) : (
        size === 'tiny' ? {
          alignItems: 'center',
          justifyContent: 'bottom',
          width: '14px',
          height: '14px',
          border: 'none',
          margin: '1px',
          padding: '1px', 
          borderRadius: '1%',
          backgroundColor: color,
          cursor: 'pointer',
          } : (
            size === 'big' ? {
              alignItems: 'center',
              justifyContent: 'top',
              width: '40px',
              height: '40px',
              border: 'none',
              margin: '5px',
              padding: '3px', 
              borderRadius: '10%',
              backgroundColor: color,
              cursor: 'pointer',
            } : ({
              alignItems: 'center',
              justifyContent: 'top',
              width: '30px',
              height: '30px',
              border: 'none',
              margin: '5px',
              padding: '3px', 
              borderRadius: '10%',
              backgroundColor: color,
              cursor: 'pointer',
          })))
      }
      onClick={onClick} onMouseEnter={mouseEnter} onMouseLeave={mouseLeave}
    >
      <img
        src={url}
        alt="SVG Button"
        style={{
          maxWidth: '100%',
          maxHeight: '100%',
          fill: 'white',
          backgroundColor: color ,
        }}
      />
    </button>
    );
  }
    
export default ImageButton;